import React from 'react'
import { PRIMARY_PAGE_TEXT_COLOR_VAR } from '../../context/CustomizationContextProvider'
import { scaledFontSize } from '../../style/scrollingLayout'
import { getTypographyRoleStyle } from '../../style/typography'
import {
    formatPriceWithoutSymbol,
    splitDollarsAndCents,
} from '../../utils/priceFormat'

export interface FormattedPriceDisplayProps {
    priceInCents: number
    currencySymbol?: string | null
    dollarsSize?: number
    centsSize?: number
    topOffset?: string
    color?: string
    className?: string
}

export const FormattedPriceDisplay: React.FC<FormattedPriceDisplayProps> = ({
    priceInCents,
    currencySymbol = '$',
    dollarsSize = 16,
    centsSize = 12,
    topOffset = '-0.2em',
    color = `var(${PRIMARY_PAGE_TEXT_COLOR_VAR})`,
    className,
}) => {
    const priceString = formatPriceWithoutSymbol(priceInCents)
    const { dollars, cents } = splitDollarsAndCents(priceString)
    const priceRole = getTypographyRoleStyle('price', {
        fontWeight: 700,
        lineHeight: 1,
    })
    const dollarsFontSize = scaledFontSize(dollarsSize)
    const centsFontSize = scaledFontSize(centsSize)

    return (
        <span
            className={className}
            style={{
                display: 'inline-flex',
                alignItems: 'baseline',
                lineHeight: 1,
                color,
            }}
        >
            <span
                style={{
                    ...priceRole,
                    fontSize: centsFontSize,
                    position: 'relative',
                    top: topOffset,
                }}
            >
                {currencySymbol || '$'}
            </span>
            <span style={{ ...priceRole, fontSize: dollarsFontSize }}>
                {dollars}
            </span>
            <span
                style={{
                    ...priceRole,
                    fontSize: centsFontSize,
                    position: 'relative',
                    top: topOffset,
                    marginLeft: 1,
                }}
            >
                {cents}
            </span>
        </span>
    )
}
